import { catchError, filter, map, mergeMap, tap } from 'rxjs/operators';
import { ofType } from 'redux-observable-es6-compat';

import { AFetchWishlist, TRemote, TWishlist } from '../actions';
import { of } from 'rxjs';

export const likeEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TWishlist.LIKE),
    //tap(() => console.log('INSIDE PIPE')),
    mergeMap(({ payload }) => restApi.put(`/like/${payload.media.id}?ngsw-bypass=true`).pipe(
      catchError(() => of(AFetchWishlist())),
    )),
    map(AFetchWishlist)
  );

export const dislikeEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TWishlist.DISLIKE),
    mergeMap(({ payload }) => restApi.delete(`/like/${payload}?ngsw-bypass=true`).pipe(
      catchError(() => of(AFetchWishlist())),
    )),
    map(AFetchWishlist)
  );

const wishlistListeners = [
  // TPlayer.SET_PLAYER_STATUS,
  TRemote.SET_REMOTE,
  TWishlist.FETCH_WISHLIST,
];
export const fetchWishlistEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => wishlistListeners.includes(type)),
    mergeMap(() => restApi.get('/event/WISHLIST')),
    map(payload => ({ type: 'SET_WISHLIST', payload })),
  );
